<svg
  [style.width.px]="size"
  [style.height.px]="size"
  viewBox="0 0 48 48"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
>
  <title>Loading</title>
  <defs></defs>
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <path
      d="M9.17868222,28.3568185 C8.87893307,27.444263 8.67682948,26.5249478 8.55647565,25.6056326 L4.24644625,21.628693 L0,25.8715129 C0.163499535,27.5704435 0.508665219,29.2761338 1.06274698,30.9683046 C2.68865902,35.9163836 5.80650431,39.972186 9.76228472,42.8067412 L8.99247441,36.8289391 L14.7194998,35.9299029 C12.2011528,34.1092983 10.2164501,31.5180912 9.17868222,28.3568185"
      class="cmx-spinner__fill-1"
    ></path>
    <path
      d="M32.7696213,35.9943451 C31.5093124,36.8933813 30.0923165,37.6211725 28.5345292,38.1213882 C25.9957448,38.9393083 23.3979188,39.0632356 20.9454258,38.603578 L15.7974613,41.4291204 L18.5610576,46.7422215 C22.6076711,47.6412577 26.9426796,47.5173304 31.1709592,46.1563834 C33.6325355,45.3655019 35.8693,44.2095982 37.8517319,42.7810545 L31.8658322,41.6566959 L32.7696213,35.9943451 Z"
      class="cmx-spinner__fill-2"
    ></path>
    <path
      d="M44.3342613,35.723733 L38.37107,36.6858594 L37.2492815,30.9739377 C39.2180884,27.4228574 39.760816,23.1124407 38.3960491,18.9597497 L43.5576386,21.5622229 L46.4870052,16.2739072 C46.4960885,16.2986926 46.5051718,16.3234781 46.5119843,16.3460103 C48.7214989,23.0808956 47.7132517,30.0771547 44.3342613,35.723733"
      class="cmx-spinner__fill-3"
    ></path>
    <path
      d="M23.8470884,8.44958836 C28.0662847,8.46536093 32.0856483,10.2161156 34.9537026,13.2174094 L40.8010818,13.9294281 L41.7184959,8.02598233 C37.2040921,2.95622931 30.645944,-0.00901289425 23.7585261,-2.04868768e-05 L27.9391184,4.39603917 L23.8470884,8.44958836 Z"
      class="cmx-spinner__fill-4"
    ></path>
    <path
      d="M9.18299679,18.9608763 C10.4592015,15.0785721 13.2931934,11.7505609 17.2035573,9.91869012 L19.6923835,4.63488087 L14.2991697,1.94453193 C7.80460488,4.72050336 3.10399325,10.1012012 1.04889493,16.4192401 L6.55110844,13.848312 L9.18299679,18.9608763 Z"
      class="cmx-spinner__fill-5"
    ></path>
  </g>
</svg>
<label *ngIf="descriptionShow" class="label"> &nbsp; {{ label }}</label>
